export enum ValuationAccuracy {
    UNSPECIFIED = 0,
    FULL_VALUATION = 1,
    QUICK_VALUATION = 2
}